import { GridColDef } from '@mui/x-data-grid';
import { PostRequestStatus } from '@libs/types';

import { PostRequestStatusChip } from '@carcareers/components';
import { DataGridLink } from '@carcareers/components';
import { routes } from '@carcareers/utils';
import { formatPhone } from '@libs/utils';

export const POST_REQUEST_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'jobTitle',
    headerName: 'Job Title',
    width: 200,
  },
  {
    field: 'employerId',
    headerName: 'Employer ID',
    width: 150,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.ADMIN_HOME}/${routes.ADMIN_EMPLOYERS_VIEW.replace(':id', params.row.employer.id.toString())}`}
        content={params.row.employer.id}
      />
    ),
  },
  {
    field: 'employer',
    headerName: 'Employer',
    width: 200,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.ADMIN_HOME}/${routes.ADMIN_EMPLOYERS_VIEW.replace(':id', params.row.employer.id.toString())}`}
        content={`${params.row.employer.user.firstName} ${params.row.employer.user.lastName}`}
      />
    ),
  },
  {
    field: 'contactName',
    headerName: 'Contact Name',
    width: 150,
  },
  {
    field: 'contactEmail',
    headerName: 'Contact Email',
    width: 200,
  },
  {
    field: 'contactPhone',
    headerName: 'Contact Phone',
    width: 150,
    valueGetter: (_, row) => formatPhone(row.contactPhone) || 'N/A',
  },
  {
    field: 'location',
    headerName: 'Location',
    width: 200,
  },
  {
    field: 'urgency',
    headerName: 'Urgency',
    width: 150,
  },
  {
    field: 'notes',
    headerName: 'Notes',
    width: 300,
  },
  {
    field: 'createdAt',
    headerName: 'Created At',
    width: 120,
    valueGetter: (_, row) =>
      new Date(row.createdAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
      }),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    valueGetter: (_, row) => row.status,
    renderCell: (params) => {
      const status: PostRequestStatus = params.value as PostRequestStatus;
      return <PostRequestStatusChip status={status} />;
    },
  },
];

export const POST_REQUEST_INDEX_COLUMN_INITIAL_STATE = {
  id: true,
  jobTitle: true,
  employerId: false,
  employer: false,
  contactName: true,
  contactEmail: true,
  contactPhone: true,
  location: true,
  urgency: true,
  notes: false,
  createdAt: true,
  status: true,
};
